import { render, staticRenderFns } from "./kuang.vue?vue&type=template&id=4a044a6a&scoped=true"
import script from "./kuang.vue?vue&type=script&lang=js"
export * from "./kuang.vue?vue&type=script&lang=js"
import style0 from "./kuang.vue?vue&type=style&index=0&id=4a044a6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a044a6a",
  null
  
)

export default component.exports